import { useAtom } from "jotai";

import { AdapexAds } from "../../../shared/components/adapex-ads.component";
import { StnAds } from "../../../shared/components/stn-ads.component";
import { quizAtom } from "../../widget.state";

export function QuestionAds({ questionIndex }: { questionIndex: number }) {
  const [quiz] = useAtom(quizAtom);

  return (
    <div className="quiz--single-page__body__question-ad">
      <div
        className={[
          "desktop",
          questionIndex % 5 === 0 && quiz.isArcade ? "autoHeight" : "",
        ].join(" ")}
      >
        {questionIndex % 5 === 0 && quiz.isArcade ? (
          <StnAds />
        ) : questionIndex % 4 === 0 ? (
          <>
            <AdapexAds adunit="fkl_300v_1" />
            <AdapexAds adunit="fkl_300v_2" />
          </>
        ) : questionIndex % 3 === 0 ? (
          <AdapexAds adunit="fkl_728v_1" />
        ) : questionIndex % 2 === 0 ? (
          <AdapexAds adunit="fkl_728v_2" />
        ) : questionIndex % 1 === 0 ? (
          <AdapexAds adunit="fkl_728v_3" />
        ) : null}
      </div>

      <div
        className={[
          "mobile",
          questionIndex % 3 === 0 ? "fixedHeight" : "fixedShortHeight",
        ].join(" ")}
      >
        {questionIndex % 3 === 0 ? (
          <AdapexAds adunit="fkl_MOB_300v_1" />
        ) : questionIndex % 2 === 0 ? (
          <AdapexAds adunit="fkl_MOB_300v_2" />
        ) : questionIndex % 1 === 0 ? (
          <AdapexAds adunit="fkl_MOB_300v_3" />
        ) : null}
      </div>
    </div>
  );
}
